import jwt_decode, { JwtPayload } from 'jwt-decode';
import getCookie from '../getCookie';

const getCarvanaUserId = () => {
  try {
    const cvIdToken = getCookie('CVIdToken') || '';
    const decodedToken = jwt_decode<JwtPayload>(cvIdToken) || {};
    return decodedToken.sub;
  } catch (e) {
    return undefined;
  }
};

export default getCarvanaUserId;
